module.exports = __webpack_public_path__ + "img/智慧空間.229373a3.jpg";